import { render, staticRenderFns } from "./hospital-list2.vue?vue&type=template&id=24e35f5e&scoped=true&"
import script from "./hospital-list2.vue?vue&type=script&lang=js&"
export * from "./hospital-list2.vue?vue&type=script&lang=js&"
import style0 from "./hospital-list2.vue?vue&type=style&index=0&id=24e35f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e35f5e",
  null
  
)

component.options.__file = "hospital-list2.vue"
export default component.exports